module.exports = __webpack_public_path__ + "img/fengcai7.69a7a4e3.png";